import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get, patch, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type remittancePayloadType = {
	group_number: number;
	carrier_name: string;
	VEB_plans: string[];
	billing_year: string;
	billing_month: string;
	start_date: string;
	end_date: string;
};

const initialRoute = "reports";

export const remittanceReport = async (remittancePayload: remittancePayloadType) => {
	try {
		const endpoint = `${initialRoute}/remittance`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			remittancePayload
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
